import React, { useState } from "react";

// Styles
import "./styles.scss";

// Redux
import { useDispatch } from "react-redux";
import { triggerEmailForForgotPasswordRequest } from "../../../../Redux/Slices/Common/commonSlice";

// Layouts
import AuthLayout from "Layouts/Auth";

// Utils
import { validateInput } from "Services/Utils/validateInput";
import { notifySuccess } from "Services/Utils/toastNotification";

// Custom components
import InputBox from "Components/InputBox";
import Button from "Components/Button";
import ErrorMessage from "Components/ErrorMessage";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  //Initialize redux
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userDetails = JSON.parse(localStorage?.getItem("userDetails"));

  // Local states
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  // Handle input change
  const handleChange = (e) => {
    setEmail(e.target.value);
    if (error) {
      setError("");
    }
  };

  // Validate and handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    const validationError = validateInput("email", email);

    if (validationError.email) {
      setError(validationError.email);
    } else {
      dispatch(
        triggerEmailForForgotPasswordRequest({
          email: email,
          callBack: triggerEmailForForgotPasswordRequestCB,
        })
      );
    }
  };

  const triggerEmailForForgotPasswordRequestCB = () => {
    notifySuccess(
      "A password reset email has been sent to your registered email address."
    );
  };

  return (
    <AuthLayout>
      <div className="user-forgot-password-root-container">
        <h1 className="user-forgot-password-heading">Forgot Password</h1>
        {/* <p className="user-forgot-password-sub-heading">Forgot Password</p> */}
        <hr className="user-forgot-password-hr" />
        <form onSubmit={handleSubmit}>
          <InputBox
            label="Email ID"
            name="email"
            value={email}
            onChange={handleChange}
            inputStyle={{ width: "85%" }}
          />
          <ErrorMessage message={error} />
          <div className="user-spacer" />
          <Button title="Submit" buttonStyle={{ width: "85%" }} forForm />
        </form>
        <div className="user-login-forgot-password-container">
          <button
            type="button"
            className="user-login-forgot-password-text"
            onClick={() => navigate("/")}
          >
            Back to Login
          </button>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
